export class GasRequestModel {
    id: number;
    bcaId: number;
    refId: string;
    countyId: string;
    landDistrict: string;
    landLot: string;
    buildOutRate: number;
    existingMainSize: string;
    minimumMainPressure: string;
    approachMainLenght: number;
    additionalCommLoad: number;
    totalHome: number;
    afeNumber: string;
    mapbook: string;
    cisGeoCode: string;
    gridNo: string;
    cisGridNo: string;
    sudDivision: string;
    companyCd: string;
    totalLots: number;
    lookerRoute: number;
    lookerRouteSeq: number;
    lookerExclude: string;
    lookerLocationType: string;
    inspectionPermitMandatory: string;
    addMeteringPressure: number;
    addRiserGroup: number;
    addProject: number;
    unitsUpdateDate: Date;
    usfAmount: number;
    gasRqstTpCd: string;
    marketerChosen: string;
    marketerId: number;
    landscaping: string;
    extendedService: string;
    enteredBy: string;
    comments: string;
    extendedHelpline: string;
    gasRequestPriority: string;
    conversionEnergySource: string;
    numberGasLightServices: number;
    spotReqdYn: string;
    notifyBypassYn: string;
    railRoadCrossing: string;
    contractRequired: string;
    letterRequired: string;
    seedProject: string;
    strideYn: string;
    existingMaterial: string;
    federalTaxId: string;
    aepNumber: string;
    customerContribution: string;
    masterMeter: string;
    strategic: string;
    psComments: string;
    psAfeProjectDescription: string;
    managingDepartment: string;
    createPsp: string;
    permitRequired: string;
    custId: string;
    plantAccountingUpdatedBy: string;
    plantAccountingUpdatedDate: Date;
    grStatus: string;
    grStatusUpdatedBy: string;
    grStatusComments: string;
    grStatusUpdatedDate: string;
    premiseType: string;
    aepValue: string;
    surcharge: string;
    surchargeApprover: string;
    updatedBy: string;
    surchargeUpdatedBy: string;
    surgeApproverUpdatedBy: string;
    applicantName: string;
    isExistingSubDivision: string;
    projectName: string;
    callerName: string;
    callerRelation: string;
    assignedToCd: string;
    development: string;
    mapServiceAddress: string;
    cityId: number;
    zipCode: string;
    gasAvailabilityRequestStatus: string;
    siteVisitRqd: string;
    mainExtnRqd: string;
    customerRdyMoveFwd: string;
    easementRqdCd: string;
    applicantCostSummaryApproval: string;
    expansionProjectCd: string;
    paymentTpCd: string;
    denialRsnCd: string;
    custRsn: string;
    energySourceCd: string;
    permitTpCd: string;
    localDistrictCd: string;
    stateCd: string;
    builderId: string;
    bcaStatus: string;
    developmentStatus: string;
    projectCategory: string;
    mainInstallationStatus: string;
    finalPlat: string;
    recCreateDttm: Date;
    recUpdateDttm: Date;
    recUpdateUsrId: string;
    recCreateUsrId: string;
    createDate: string;
    bcaTypeCd: string;
    serviceFormattedAddress: string;
    mailingFormattedAddress: string;
    pinFormattedAddress: string;
    buildingId: string;
    sourceCd: string;
    contacts: Contact[];
    addresses: Address[];
    gasRequestTypeAndPremiseDetails: GasRequestTypeAndPremiseDetails[];
    premiseId: string;
    bcaNameUpdate: string;
    kmiCommunication: string;
    kmiPreference: string;
    kmiEmail: string;
    kmiPhoneNo: string;
    kmiFrequency: string;
    KMITransactionStatus: string;
    constructor() {
      this.id = 0;
      this.bcaId = null;
      this.refId = null;
      this.countyId = null;
      this.landDistrict = null;
      this.landLot = null;
      this.buildOutRate = null;
      this.marketerId = null;
      this.landscaping = null;
      this.extendedService = null;
      this.enteredBy = null;
      this.comments = null;
      this.extendedHelpline = null;
      this.gasRequestPriority = null;
      this.conversionEnergySource = null;
      this.numberGasLightServices = null;
      this.spotReqdYn = null;
      this.notifyBypassYn = null;
      this.existingMainSize = null;
      this.minimumMainPressure = null;
      this.approachMainLenght = null;
      this.additionalCommLoad = null;
      this.totalHome = null;
      this.afeNumber = null;
      this.mapbook = null;
      this.cisGeoCode = null;
      this.gridNo = null;
      this.cisGridNo = null;
      this.sudDivision = null;
      this.companyCd = null;
      this.totalLots = null;
      this.lookerRoute = null;
      this.lookerRouteSeq = null;
      this.lookerExclude = null;
      this.lookerLocationType = null;
      this.inspectionPermitMandatory = null;
      this.addMeteringPressure = null;
      this.addRiserGroup = null;
      this.addProject = null;
      this.unitsUpdateDate = null;
      this.usfAmount = null;
      this.gasRqstTpCd = null;
      this.railRoadCrossing = null;
      this.contractRequired = null;
      this.letterRequired = null;
      this.seedProject = null;
      this.strideYn = null;
      this.existingMaterial = null;
      this.federalTaxId = null;
      this.aepNumber = null;
      this.customerContribution = null;
      this.masterMeter = null;
      this.strategic = null;
      this.psComments = null;
      this.psAfeProjectDescription = null;
      this.managingDepartment = null;
      this.createPsp = null;
      this.permitRequired = null;
      this.custId = null;
      this.plantAccountingUpdatedBy = null;
      this.plantAccountingUpdatedDate = null;
      this.grStatus = null;
      this.grStatusUpdatedBy = null;
      this.grStatusComments = null;
      this.premiseType = null;
      this.aepValue = null;
      this.surcharge = null;
      this.surchargeApprover = null;
      this.updatedBy = null;
      this.surchargeUpdatedBy = null;
      this.surgeApproverUpdatedBy = null;
      this.applicantName = null;
      this.isExistingSubDivision = null;
      this.projectName = null;
      this.callerName = null;
      this.callerRelation = null;
      this.assignedToCd = null;
      this.development = null;
      this.mapServiceAddress = null;
      this.cityId = null;
      this.zipCode = null;
      this.gasAvailabilityRequestStatus = null;
      this.siteVisitRqd = null;
      this.mainExtnRqd = null;
      this.customerRdyMoveFwd = null;
      this.easementRqdCd = null;
      this.applicantCostSummaryApproval = null;
      this.expansionProjectCd = null;
      this.paymentTpCd = null;
      this.denialRsnCd = null;
      this.custRsn = null;
      this.energySourceCd = null;
      this.permitTpCd = null;
      this.localDistrictCd = null;
      this.stateCd = null;
      this.builderId = null;
      this.bcaStatus = null;
      this.developmentStatus = null;
      this.projectCategory = null;
      this.mainInstallationStatus = null;
      this.finalPlat = null;
      this.bcaTypeCd = null;
      this.serviceFormattedAddress = null;
      this.mailingFormattedAddress = null;
      this.pinFormattedAddress = null;
      this.buildingId = null;
      this.sourceCd = null;
      this.recCreateDttm = new Date() ;
      this.recUpdateDttm = new Date();
      this.recUpdateUsrId = null;
      this.recCreateUsrId = null;
      this.contacts = [];
      this.addresses = [];
      this.gasRequestTypeAndPremiseDetails = [];
      this.premiseId = null;
      this.bcaNameUpdate = null;
      this.kmiCommunication = null;
      this.kmiPreference = null;
      this.kmiEmail = null;
      this.kmiPhoneNo = null;
      this.kmiFrequency = null;
      this.KMITransactionStatus = null;
        
    }
  }
  export class Contact {
    id: number;
    firstName: string;
    middleInitial: string;
    emailAddress: string;
    companyName: string;
    lastName: string;
    contactTypeCode: string;
    communicationTypeCode: string;
    gasRequestId: number;
    siteContactType: string;
    siteContactTypeOthers: string;
    contactPhoneNumbers: ContactPhoneNumber[];
  }
  export class ContactPhoneNumber {
    id: number;
    contactId: number;
    phoneNumber: string;
    extension: string;
  }
  export class Address {
    id: number;
    gasRequestId: number;
    addressTypeCode: string;
    streetNumber: number;
    streetName: string;
    unitNumber: string;
    cityId: number;
    zip: string;
    stateCd: string;
    countyId: string;
  }
  export class GasRequestTypeAndPremiseDetails {
    id: number;
    gasRequestId: number;
    questionId: number;
    questionResponse: string;
    recordCreatedBy: string;
    sequenceId: number;
    gasApplianceQuestSummaries: GasApplianceQuestSummary[];

  }
  export class GasApplianceQuestSummary {
    id: number;
    gasRequestId: number;
    questionId: number;
    sequenceId: number;
    applianceId: number;
    quantityValue: string;
    loadValue: string;
    recordCreatedBy: string;
    applianceOthers: string;
    existingLoad: string;
  }
